<div
  *ngIf="step"
  class="guided-tour">
  <div class="guided-tour__overlay">
    <e-guided-tour-skeleton
      (exitDemoClick)="onExitDemoClick()"
      *ngIf="showSkeleton"
      @fadeOut
      [step]="step"></e-guided-tour-skeleton>

    <ng-container *ngIf="!showSkeleton">
      <e-portal
        [stepPortal]="step.portal"
        class="guided-tour__portal"
      ></e-portal>

      <e-exposed-element
        (exposedElementClick)="onExposedElementClick()"
        *ngIf="step.portal.exposedElement"
        [stepExposedElement]="step.portal.exposedElement"
      ></e-exposed-element>

      <e-guided-tour-dialog
        (exitDemoClick)="onExitDemoClick()"
        (nextStepClick)="onNextStepClick()"
        [ngClass]="{'portal__overlay--fixed': step && step.dialog.position === 'fixed'}"
        [step]="step"
        class="guided-tour__step"
      ></e-guided-tour-dialog>
    </ng-container>

  </div>
</div>

